import api from "api";

export const getEngagementDetails = (params) => {
  return api.get(`/v1/qaIntegration/engagementDetail`, { params });
};

export const getQAFilters = () => {
  return api.get('/v1/qaIntegration/qaFilters');
};

export const getScoringFormWithRecording = (formFilledPurpose,isIvrFormRequired,engagementTrackingId, coachUserId) => {
  return api.get(`/v1/qaIntegration/scoringFormWithRecording/${engagementTrackingId}`, {
    params: {
      coachUserId,
      formFilledPurpose,
      isIvrFormRequired
    },
  });
};


export const postScoringForm = (data) => {
  return api.post('/v1/qaIntegration/scoringForm', data);
};

export const postFeedBackForm = (data) => {
  return api.post('/v1/qaIntegration/feedbackForm', data);
};

export const getAllQaScoringAndFeedbackForm = (params) => {
  return api.get('/v1/qaIntegration/getAllQaScoringAndFeedbackForm', { params });
};

export const getFeedBackForm = (id) => {
  return api.get(`/v1/qaIntegration/feedbackForm/${id}`);
};

export const getQaAuditDataForGraphDesign = (params) => {
  return api.get('/v1/qaIntegration/auditDataForGraph', { params });
};

export const getAllAgentAndQaList = () => {
  return api.get('/v1/qaIntegration/allAgentsAndQa');
};

export const assignAgentsToQa = () => {
  return api.post('/v1/qaIntegration/assignAgentToQa');
};

export const downloadQaAuditData = (params) => {
  return api.get(`/v1/qaIntegration/downloadQaAuditData`, { params });
};

export const  getLocationView = (queryParams) => {
  return api.get(`/v1/qaIntegration/getViewByLocation${queryParams}`);
};

export const getLocationViewFilterData = () => {
  return api.get(`/v1/qaIntegration/locationViewFilter`);
};

export const getCoachView = (queryParams) => {
  return api.get(`/v1/qaIntegration/getViewByCoach${queryParams}`);
};

export const getCoachViewFilterData = () => {
  return api.get(`/v1/qaIntegration/coachViewFilter`);
};

export const getQaView = (queryParams) => {
  return api.get(`/v1/qaIntegration/getViewByQa${queryParams}`);
};

export const getQaViewFilterData = () => {
  return api.get(`/v1/qaIntegration/qaViewFilter`);
};

export const getDisputeApply = (body) => {
  return api.post(`/v1/qaIntegration/addDisputeQuestions`,body);
};

export const getDisputeReject = (id) => {
  return api.put(`/v1/qaIntegration/rejectDisputeRequest/${id}`);
};